import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import BottomScrollListener from 'react-bottom-scroll-listener';

import SearchInput from 'components/Form/SearchInput';
import DatesSelector from 'components/DateRangePicker';
import Detail from 'components/Detail';
import Table from 'components/TableWithoutPagination';
import {
  Container,
  Header,
  DateCaption,
  SearchInputContainer,
  BrandSelect,
  LoaderWrapper,
  Spinner,
  Loader,
} from './styles';
import useConnect from './connect';

const History: React.FC = () => {
  const {
    orders,
    search,
    setSearch,
    selectedBrandId,
    setSelectedBrandId,
    from,
    setFrom,
    to,
    setTo,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  } = useConnect();

  return (
    <>
      {isFetching && !isFetchingNextPage && <Loader />}
      <Container>
        <Header>
          <DateCaption>Date range</DateCaption>
          <DatesSelector
            from={from}
            fromHandleChange={setFrom}
            to={to}
            toHandleChange={setTo}
          />
          <BrandSelect
            value={selectedBrandId}
            allowAllOption
            setSelectedId={setSelectedBrandId}
          />
          <SearchInputContainer>
            <SearchInput value={search} onChangeValue={setSearch} />
          </SearchInputContainer>
        </Header>
        <Switch>
          <Route exact path="/history">
            <>
              <Table
                orders={orders}
                isLoading={isFetching && !isFetchingNextPage}
              />
              {isFetchingNextPage && (
                <LoaderWrapper>
                  <Spinner />
                </LoaderWrapper>
              )}
              {hasNextPage && !isFetching && (
                <BottomScrollListener
                  triggerOnNoScroll
                  onBottom={() => fetchNextPage()}
                />
              )}
            </>
          </Route>
          <Route path="/history/:orderId" component={Detail} />
          <Redirect to="/history" />
        </Switch>
      </Container>
    </>
  );
};

export default History;
